module.exports = __webpack_public_path__ + "img/workContents06-01.4c800933.png";